import React, { useState } from "react";
import { useMutation } from "react-query";
import { PASST_AUTORENEWAL } from "../../services/common/endpoints";
import { callQueryapi } from "../../services/http/callapi";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "./confirmation-modal";
import { SELECTED_LANG } from "../../services/common/Constants";
import { getItemOfSessionStorage } from "../../services/common/utils";

const PackAndSubscriptionsActionToggle = ({ passportData, item, index }) => {
  const lang = getItemOfSessionStorage(SELECTED_LANG);
  const [popupShow, setPopupShow] = useState(false);
  const [checked, setChecked] = useState(passportData?.autorenewal);
  const navigate = useNavigate();
  const toggleModal = () => {
    setPopupShow(!popupShow);
  };
  const packToggleOnOff = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [{}, PASST_AUTORENEWAL, req],
      }),
    {
      onSuccess: (udata) => {
        const status = udata?.data?.status;
        const infomsg = udata?.data?.infomsg;
        const message = udata?.data?.message;
        try {
          if (status === "0") {
            navigate("/transactionstatus", {
              state: { isoffline: true, isuccess: true, info_message: infomsg, message: message },
            });
          } else {
            setChecked(!checked);
            navigate("/transactionstatus", {
              state: { isoffline: true, isuccess: false, info_message: infomsg, message: message },
            });
          }
        } catch (e) {
          setChecked(!checked);
          navigate("/transactionstatus", {
            state: { isoffline: true, isuccess: false, info_message: "", message: "" },
          });
        }
      }
    }
  );

  const onOffTogglePacks = (e) => {
    let params = {
      msisdn: "",
      status: passportData?.autorenewal,
      offerid: item?.offerId,
      keyword: passportData?.keyword,
    };
    packToggleOnOff.mutate(params);
  };

  return (
    <>
    {/* switch-rotate-180 */}
    <div class={`event_img d-flex ${lang === 'ar' ? 'switch-rotate-180' : ''}`}>
    <div class="cs_toggle_btn">
      <input type="checkbox" name="toggle" id={(index + 1).toString()} checked={checked} onChange={(e) => {
        setChecked(e.target.checked);
        setPopupShow(true);
      }} />
      <label htmlFor={(index + 1).toString()}>&nbsp;</label>
    </div>
    </div>

      <ConfirmationModal
        title={''}
        description={passportData?.autorenewal
          ? passportData?.cppopup?.deactivate_message
          : passportData?.cppopup?.activate_message}
        cancelText={passportData?.cppopup?.cancel_button}
        show={popupShow}
        submitText={passportData?.autorenewal
          ? passportData?.cppopup?.deactivate_button
          : passportData?.cppopup?.activate_button}
        toggleModal={() => {
          setChecked(!checked);
          toggleModal();
        }}
        submit={onOffTogglePacks}
        loading={packToggleOnOff?.isLoading}
      />
    </>
  );
};

export default PackAndSubscriptionsActionToggle;
